import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhatIsSection from './components/WhatIsSection';
import WhyVigorbuySection from './components/WhyVigorbuySection';
import CategoriesSection from './components/CategoriesSection';
import HowItWorksSection from './components/HowItWorksSection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://vigorbuyspread.homes';
const LOGO_URL = 'https://static.readdy.io/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Vigorbuy Spread',
            url: SITE_URL,
            description: 'Your complete resource for Vigorbuy Spreadsheet - organized product categories, buying guides, and expert shopping strategies.',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${SITE_URL}search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Vigorbuy Spread',
            url: SITE_URL,
            logo: LOGO_URL,
            description: 'Your complete resource for Vigorbuy Spreadsheet - organized product categories, buying guides, and expert shopping strategies.',
            sameAs: ['https://kaspreadsheet.com'],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: SITE_URL,
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <WhatIsSection />
        <WhyVigorbuySection />
        <CategoriesSection />
        <HowItWorksSection />
        <ArticleSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}